/**
 * Selo "Adicionar à Carteira do Google" em vetor (nítido em qualquer tela), no
 * mesmo formato do selo da Apple (`/applewallet.svg`): fundo preto, borda
 * cinza, ícone à esquerda e texto em duas linhas.
 */
export function GoogleWalletBadge() {
  return (
    <span className="inline-flex h-12 items-center gap-2.5 rounded-[0.6rem] border border-[#A6A6A6] bg-black pl-3 pr-4 text-left text-white">
      <svg viewBox="0 0 32 26" className="h-7 w-auto shrink-0" aria-hidden="true">
        <rect x="2" y="1" width="28" height="9" rx="3" fill="#34A853" />
        <rect x="2" y="5.5" width="28" height="9" rx="3" fill="#FBBC04" />
        <rect x="2" y="10" width="28" height="9" rx="3" fill="#EA4335" />
        <path d="M2 14.5h28V22a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3z" fill="#4285F4" />
      </svg>
      <span className="leading-none">
        <span className="block text-[11px] font-normal tracking-wide">Adicionar à</span>
        <span className="mt-0.5 block whitespace-nowrap text-[17px] font-medium tracking-tight">
          Carteira do Google
        </span>
      </span>
    </span>
  );
}
